import config from './index.json';

const environmentMapping = {
  'dev-telemedicina.medex.net.br': 'development',
  'dev-telemedicina.bhiotrack.com.br': 'development',
  'uat-telemedicina.medex.net.br': 'uat',
  'uat-telemedicina.bhiotrack.com.br': 'uat',
  'ppr-telemedicina.medex.net.br': 'ppr',
  'ppr-telemedicina.bhiotrack.com.br': 'ppr',
  'ppr-klinitelemedicina.medex.net.br': 'ppr-klini',
  'ppr-klinitelemedicina.bhiotrack.com.br': 'ppr-klini',
};

const currentHost = location.host;
const currentEnvironment = environmentMapping[currentHost] || process.env.NODE_ENV || 'production';
const productionHttp = `https://${currentHost}/v1`;

export const environments = {
  tmed: currentEnvironment === 'production' ? productionHttp : config[currentEnvironment]?.tmed,
  tmedQueue: config[currentEnvironment]?.tmed || config.production.tmed,
  partner: config[currentEnvironment]?.partner || config.production.partner,
  socket: config[currentEnvironment]?.socket || config.production.socket,
  planApi: config[currentEnvironment]?.planApi || config.production.planApi,
};
